<template>
  <div class="page">
    <Header></Header>
    <div class="body">
      <div class="header-box">
        <div>
          <div class="box-title-text">{{postion.name}}</div>
        </div>
        <div class="box-tags">
          <van-tag v-if="postion.showWorkPlace" color="#e4ecfa" text-color="#206CFE">{{postion.showWorkPlace}}</van-tag>
<!--          <van-tag style="white-space: normal;" v-if="postion.tags" color="#f5eee9" text-color="#FF8E25">{{postion.tags}}</van-tag>-->
        </div>
      </div>
      <div class="box-split"></div>
      <div class="box">
        <div class="duty-title"><span class="duty-icon"></span>工作职责</div>
        <div class="duty-body">
          <div class="duty-txt">
            <p v-for="(item,i) in postion.responsibilities" :key="'p'+i">{{item}}</p>
          </div>
        </div>
      </div>
      <div class="box-split"></div>
      <div class="box">
        <div class="duty-title"><span class="duty-icon"></span>岗位要求</div>
        <div class="duty-body">
          <div class="duty-txt">
            <p v-for="(item,i) in postion.requirement" :key="'q'+i">{{item}}</p>
          </div>
        </div>
      </div>
      <div style="height:80px;"></div>
      <SafeBottom></SafeBottom>
    </div>
    <div class="footer">
      <button class="footer-btn--left" @click="delivery">立即投递</button>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Toast,
  Tag
} from "vant";
import Urls from "../utils/Urls";
import Request from "../utils/Request";
import Utils from "../utils/Utils";
import wx from "weixin-js-sdk";
import Header from "./Header1";
import Footer from "./Footer";
import SafeBottom from "./SafeBottom";
Vue.use(Tag);
export default {
  name: 'Postion',
  components:{
    SafeBottom,
    Header,
    Footer
  },
  data() {
    return {
      app:"",
      s: "",
      loading:false,
      postion: {
      },
      showShare:false,
    };
  },
  mounted: function() {
    this.app=Utils.getApp();
    this.getPostion();
  },
  methods: {
    getPostion() {
      let that=this;
      this.loading=true;
      Toast.loading({
        duration: 0,
        forbidClick: true,
      });
      Request.request(Urls.getPositionDetail, { positionId:this.$route.query.id }).then(data => {
        that.loading=false;
        Toast.clear();
        if (data) {
          if(data.requirement) {
            data.requirement=data.requirement.split('\n');
          }
          if(data.responsibilities) {
            data.responsibilities=data.responsibilities.split('\n');
          }
          that.postion = data;
        }
      });
    },
    delivery()
    {
      let that=this;
      Toast.loading({
        duration: 0,
        forbidClick: true,
      });
      Request.request(Urls.checkDelivery, { positionId:this.postion.id }).then(data => {
        Toast.clear();
        if (data)
        {
          that.$Dialog.confirm({
            title: '提示',
            message: '您已经投递过'+(that.postion.targetId=='1004'?data.positionName+'，不能再投递其他职位':'了，不能在投递此职位了'),
            cancelButtonText:''
          });
        }
        else
        {
          if(data===null)
          {
                that.$Dialog.confirm({
                  title: '提示',
                  message: '每位同学只能投递一个职位,\n确认要申请该职位吗?',
                })
                .then(() => {
                  if (that.app == 'WeiXinMini' && that.$route.query.minipage == 'm') {
                    Toast.loading({
                      duration: 500,
                      forbidClick: true,
                    });
                    wx.miniProgram.navigateTo({
                      url: '/pages/m/child?url=delivery&param=' + encodeURIComponent('id=' + that.postion.id),
                      complete: () => {
                        Toast.clear();
                      }
                    });
                  } else {
                    that.$router.push({path: '/delivery', query: {id: that.postion.id}});
                  }
                })
                .catch(() => {
                  // on cancel
                });
          }
        }
      });
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page {
  background-color: #F5F7FA;
  /*height: 100%;*/
  flex:1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.body{
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.header-box{
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 16px;
  margin-bottom: 25px;
}
.box {
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 16px;
  margin-bottom: 16px;
  border-radius: 12px;
  background-color: #FFFFFF;
  padding: 16px;
}
.box-title-text {
  /*height: 22px;*/
  font-family: PingFangSC-Medium;
  font-size: 20px;
  color: #20253F;
  line-height: 22px;
  font-weight: 500;
}
.box-btn {
  float:right;
  width:68px !important;
  height: 32px;
  line-height: 30px !important;
  background-color: #FFFFFF;
  border: 1px solid #CCDCFF;
  border-radius: 4px;
  font-family: PingFangSC-Medium;
  font-size: 12px;
  color: #3E62FF;
  font-weight: normal;
  padding: 0px !important;
  text-align: center;
}
.box-tags {
  margin-top: 8px;
  display: flex;
  align-items: flex-start;
}
.van-tag{
  display: block;
  border-radius: 2px;
  padding:1px 3px;
  white-space: nowrap;
}
.ellipsis{
  overflow: hidden;
  text-overflow: ellipsis;
}
.van-tag+.van-tag
{
  margin-left: 11px;
}


.box-split {
  height: 0;
  background-color: #F5F7FA;
}



.duty-title {
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #20253F;
  line-height: 18px;
  font-weight: 500;
  display: flex;
  align-items: center;
}
.duty-icon{
  display: block;
  width: 3px;
  height: 13px;
  background:linear-gradient(to bottom,#206CFE 0%,#206CFE 50%,red 51%,red 100%);
  margin-right: 8px;
  margin-top: 1px;
}
.duty-body {
  margin-top: 12px;
}
.duty-txt {
  font-family: PingFangSC-Regular;
  font-size: 13px;
  color: #666D7F;
  line-height: 18px;
  font-weight: 400;
  word-wrap: break-word;
  word-break: break-all;
  margin-bottom: 20px;
}
.duty-txt p{
  padding: 0;
  margin: 0;
}
.duty-txt p+p{
  margin-top: 8px;
}
.footer {
  width: calc(100% - 32px);
  background-color: #ffffff;
  padding: 16px;
  justify-content: center;
  position: fixed;
  bottom: 0;
  display: flex;
  flex-direction: row;
}

.footer-btn--left {
  width: 100% !important;
  height: 44px;
  line-height: 44px;
  display: inline-block;
  background-image: linear-gradient(270deg, #206CFE 0%, #4C88FF 100%);
  border-radius: 6px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #FFFFFF;
  font-weight: 400;
  text-align: center;
  padding: 0px !important;
  border: 0;
}

.footer-btn--right {
  width: 100% !important;
  height: 48px;
  line-height: 48px;
  display: inline-block;
  background: #f2f4f5;
  border-radius: 6px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #20253f;
  font-weight: normal;
  text-align: center;
  padding: 0px !important;
  border: 0;
}



</style>
